import { createSelector } from 'reselect';
import { NONE_CHOOSEN } from '../../utils/gtmEvents';
import { getCurrentFilterParams, getTripTypes, getSelectedTripTypes } from './filtersSelectors';

export const getExponeaData = createSelector(
  [getCurrentFilterParams, getTripTypes, getSelectedTripTypes],
  (currentFilterParams, tripTypes, selectedTripTypes) => {
    const travelTypeCodes = tripTypes
      .filter((tt) => selectedTripTypes.indexOf(tt.key) >= 0)
      .map((tt) => tt.gtm.value);

    return {
      travel_adults: NONE_CHOOSEN,
      travel_children: NONE_CHOOSEN,
      travel_country_code: NONE_CHOOSEN,
      travel_departure_code: currentFilterParams.departure.length
        ? currentFilterParams.departure.join()
        : NONE_CHOOSEN,
      travel_destination_code: NONE_CHOOSEN,
      travel_duration: NONE_CHOOSEN,
      page_type_url: 'static/LMSList',
      travel_pax: NONE_CHOOSEN,
      travel_ages: NONE_CHOOSEN,
      travel_type: travelTypeCodes.length ? travelTypeCodes.join() : NONE_CHOOSEN,
      travel_departure_timestamp: NONE_CHOOSEN,
    };
  },
);
